import { Chip } from "@legal-500/legal500-design-system";
import type { PackageWithFeatureCodes } from "../../api/packages.service";
import styles from "./PackageCard.module.css";

export type PackageCardProps = {
  package: PackageWithFeatureCodes;
  onClick?: (pkg: PackageWithFeatureCodes) => void;
};

export function PackageCard({ package: pkg, onClick }: PackageCardProps) {
  const handleClick = () => {
    onClick?.(pkg);
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onClick?.(pkg);
    }
  };

  const packageType = pkg.type === "default" ? "DEFAULT" : "PRODUCT";
  const statusLabel = pkg.isActive ? "Active" : "Inactive";
  const featureCount = pkg.featureCodes?.length || 0;

  return (
    <div
      className={styles.card}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      aria-label={`Package ${pkg.productCode}`}
    >
      <div className={styles.header}>
        <h3 className={styles.productCode}>{pkg.name}</h3>
        <div className={styles.badges}>
          <Chip size="small" variant="filled" className={styles.versionBadge}>
            v{pkg.version}
          </Chip>
          <Chip
            size="small"
            variant="outlined"
            className={pkg.isActive ? styles.statusActive : styles.statusInactive}
          >
            {statusLabel}
          </Chip>
        </div>
      </div>

      <div className={styles.content}>
        <div className={styles.field}>
          <span className={styles.label}>Code</span>
          <span className={styles.value}>{pkg.productCode}</span>
        </div>

        <div className={styles.field}>
          <span className={styles.label}>Description</span>
          <span className={`${styles.value} ${styles.description}`}>
            {pkg.description || "(not set)"}
          </span>
        </div>

        <div className={styles.footer}>
          <Chip size="small" variant="filled" className={styles.typeBadge}>
            {packageType}
          </Chip>
          <span className={styles.featureCount}>{featureCount} features</span>
        </div>
      </div>
    </div>
  );
}
